import SkeletonHome from './Home';
import SkeletonGlossary from './Glossary';
import SkeletonFaq from './Faq';

export default {
  functional: true,
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '/',
    },
  },
  render (createElement, context) {
    const { loading, path } = context.props;
    if (!loading) {
      return context.children;
    }
    const getCurrentComponent = () => {
      switch (path) {
        case '/faq':
          return SkeletonFaq;
        case '/glossary':
          return SkeletonGlossary;
        case '/':
        default:
          return SkeletonHome;
      }
    }
    return createElement(getCurrentComponent());
  }
}
